export type LayoutMenu = "machine" | "plot_plan" | "machine_type" | "icon_color" | "plot_plan_mapping";
